// extracted by mini-css-extract-plugin
var _1 = "Nav-module_nav_badge__F8_Nau";
var _2 = "Nav-module_nav_delimiter__Z4NHkz";
var _3 = "Nav-module_nav_icon__aZHU1a";
var _4 = "Nav-module_navbar_nav__Jaw6pX";
export { _1 as "nav_badge", _2 as "nav_delimiter", _3 as "nav_icon", _4 as "navbar_nav" }
